import { action, observable } from 'mobx';
import {
  AttributionWindowEnum,
  CampaignSettingsPublishersQuery_publishers_edges_node,
  DateRangeEnum,
  LevelEnum,
  PerformanceRule_performanceRule,
  PerformanceRules_performanceRules_edges_node,
  RulesInput,
  StatusEnum,
  TriggerFieldEnum
} from 'api';
import { useRootStore } from '../../index';

export class RulesStore {
  @observable publisherRules: [PerformanceRules_performanceRules_edges_node] | undefined;
  @observable rule: PerformanceRule_performanceRule | undefined;
  @observable publisher: CampaignSettingsPublishersQuery_publishers_edges_node | undefined | null;

  @action setPublishersRules = (publisherRules: [PerformanceRules_performanceRules_edges_node]) =>
    (this.publisherRules = publisherRules);
  @action setRule = (rule: PerformanceRule_performanceRule) => (this.rule = rule);
  @action setPublisher = (publisher: CampaignSettingsPublishersQuery_publishers_edges_node | undefined | null) =>
    (this.publisher = publisher);

  @observable attributes: RulesInput = {
    id: '',
    name: '',
    level: LevelEnum.campaign,
    subLevel: null,
    status: StatusEnum.enabled,
    goal: 0,
    dateRange: DateRangeEnum.LIFETIME,
    articleIds: null,
    campaignId: '',
    triggerField: TriggerFieldEnum.impressions,
    minSpend: null,
    attributionWindow: AttributionWindowEnum.default
  };
  @action setAttributes = (newAttributes: RulesInput) => (this.attributes = newAttributes);
}

export const useRulesStore = (): RulesStore => {
  const store = useRootStore();
  if (!store.rulesStore) throw new Error('CT store has not been initialized');
  return store.rulesStore;
};
